var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":("modal-alert-rule-branch-edit-" + (_vm.branchData.branchId)),"title":("Editar Regra de Filial " + (_vm.branchData.name)),"size":"xl","ok-title":"Salvar","cancel-title":"Cancelar"},on:{"ok":_vm.editRule}},[_c('edit-rule-component',{attrs:{"branchRuleId":_vm.branchData.rule}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe3ab91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/modal-alert-rule-branch-edit/index.vue
// module id = null
// module chunks = 